/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { useNavigate } from "react-router-dom";

const tiles = [
  { label: "Employee List",       path: "/employee-list",       icon: "👥", desc: "View & manage all employees" },
  { label: "Employee onboarding", path: "/employee-onboarding", icon: "📋", desc: "Register & capture full employee details" },
  { label: "Set Passwords",       path: "/employee-passwords",  icon: "🔒", desc: "Manage employee login passwords" },
  { label: "Attendance Approvals",path: "/employee-attendance", icon: "📅", desc: "Approve or reject attendance" },
  { label: "Attendance Records",  path: "/employee-att-records",icon: "📋", desc: "View historical attendance" },
  { label: "Leave Requests",      path: "/employee-leave",      icon: "🏖️", desc: "Manage employee leaves" },
  { label: "Advance Requests",    path: "/employee-advance",    icon: "💰", desc: "Advance approval & records" },
  { label: "Salary",              path: "/employee-salary",     icon: "💵", desc: "Payroll & salary processing" },
  { label: "Deduction",           path: "/employee-deduction",  icon: "📉", desc: "Track employee deductions" },
  { label: "Escalations",         path: "/employee-escalations",icon: "🚨", desc: "View & resolve escalations" },
  { label: "Schedule Config",     path: "/employee-schedule",   icon: "⏱️", desc: "Set fill & shift schedules" },
  { label: "Timesheet",           path: "/employee-timesheet",  icon: "⏰", desc: "Duty hours tracking" },
];

export default function EmployeeManagement() {
  const nav = useNavigate();
  return (
    <div className="sendo-page">
      <h2 className="sendo-heading">Employee Management</h2>
      <div style={{
        padding: "24px",
        display: "grid",
        gridTemplateColumns: "repeat(3, 1fr)",
        gap: "18px",
      }}>
        {tiles.map(t => (
          <div
            key={t.path}
            onClick={() => nav(t.path)}
            style={{
              backgroundColor: "#fff",
              borderRadius: "8px",
              padding: "28px 16px",
              textAlign: "center",
              cursor: "pointer",
              boxShadow: "0 2px 8px rgba(0,0,0,0.10)",
              border: "2px solid transparent",
              transition: "all 0.15s",
            }}
            onMouseEnter={e => {
              e.currentTarget.style.borderColor = "#FFC107";
              e.currentTarget.style.transform = "translateY(-3px)";
            }}
            onMouseLeave={e => {
              e.currentTarget.style.borderColor = "transparent";
              e.currentTarget.style.transform = "";
            }}
          >
            <div style={{ fontSize: 34, marginBottom: 8 }}>{t.icon}</div>
            <div style={{ fontWeight: "bold", fontSize: 13, marginBottom: 5, color: "#111" }}>{t.label}</div>
            <div style={{ fontSize: 11, color: "#888" }}>{t.desc}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
